import { Settings } from '@mui/icons-material';
import IconeCalendario from '@mui/icons-material/CalendarMonth';
import FormatListBulleted from '@mui/icons-material/FormatListBulleted';
import Gavel from '@mui/icons-material/Gavel';
import MenuIcon from '@mui/icons-material/Menu';
import ScreenSearchDesktopOutlinedIcon from '@mui/icons-material/ScreenSearchDesktopOutlined';
import {
    Box,
    Drawer,
    IconButton,
    LinearProgress,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText
} from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { action, reaction, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import Rota, { ROTA } from '../dominio/Rota';
import InformacoesApp from './InformacoesApp';
import Legenda from './Legenda';
import ListaSessoes from './ListaSessoes';
import PainelUsuarioLogado from './PainelUsuarioLogado';
import ReactComponent from './ReactComponent';

class MenuAppBar extends ReactComponent {
    menuAberto = false;
    rota = this.identificarRota(this.routerStore.location.pathname);
    baseUrl = process.env.PUBLIC_URL ? process.env.PUBLIC_URL : '';

    constructor(props) {
        super(props);

        makeObservable(this, {
            menuAberto: observable,
            rota: observable,
            atualizarRotas: action,
            atualizarRota: action,
            toggleMenu: action,
            renderOpcaoMenu: computed,
            renderDrawerMenu: computed,
            renderModuloSelecionado: computed
        });

        this.createReaction(
            reaction(
                () => this.routerStore.location.pathname,
                () => this.atualizarRotas(this.routerStore.location.pathname)
            )
        );
    }

    atualizarRotas(rotas) {
        this.rota = this.identificarRota(rotas);
    }

    identificarRota(rotas) {
        const path = rotas;
        const nomeRotaLimpa = path?.substring(path?.lastIndexOf('/'));
        return Rota.getObjectByRota(nomeRotaLimpa);
    }

    exibirMenu = () => {
        return (
            this.usuarioStore.isUsuarioLogado &&
            this.routerStore.location.pathname !== '/' &&
            this.routerStore.location.pathname !== ROTA.ACOMPANHAMENTO_SESSAO.rota
        );
    };

    handleClickTelaPrincipal = () => {
        this.toggleMenu();
        this.atualizarRota(ROTA.MENU);
    };

    handleClickSalaSessao = () => {
        this.toggleMenu();
        this.atualizarRota(ROTA.SESSAO);
    };

    handleClickCalendario = () => {
        this.toggleMenu();
        this.atualizarRota(ROTA.CALENDARIO);
    };

    handleClickAdicionarProcessosPauta = () => {
        this.toggleMenu();
        this.atualizarRota(ROTA.PAUTA);
    };

    handleClickConfiguracaoParametros = () => {
        this.toggleMenu();
        this.atualizarRota(ROTA.ADMIN);
    };

    handleClickPreSessao = () => {
        this.toggleMenu();
        this.atualizarRota(ROTA.PRE_SESSAO);
    };

    atualizarRota(r) {
        this.rota = r;
        this.redirecionar(r.rota);
    }

    toggleMenu = () => {
        this.menuAberto = !this.menuAberto;
    };

    render() {
        return (
            <Box id="divMenuAppBar">
                <AppBar position="static">
                    <Toolbar
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            padding: '0px',
                            minHeight: '36px',
                            paddingTop: '5px'
                        }}
                        variant="dense"
                    >
                        {this.renderOpcaoMenu}
                        <Box
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexWrap: 'nowrap',
                                marginRight: '10px',
                                height: '30px'
                            }}
                        >
                            <ListaSessoes />
                        </Box>
                        <Box
                            style={{
                                width: '38%',
                                height: '36px',
                                display: 'flex',
                                justifyContent: 'flex-end',
                                alignItems: 'center'
                            }}
                        >
                            <PainelUsuarioLogado />
                            <InformacoesApp
                                exibirNome={true}
                                exibirDependencias={true}
                                exibirVersao={true}
                                exibirAmbiente={true}
                            />
                            {this.exibirMenu() && <Legenda />}
                        </Box>
                    </Toolbar>
                    {this.appStore.requisicoesPendentes ? (
                        <LinearProgress color="secondary" />
                    ) : (
                        <LinearProgress
                            variant="determinate"
                            value={100}
                        />
                    )}
                </AppBar>
            </Box>
        );
    }

    get renderOpcaoMenu() {
        return (
            <Box style={{ width: '38%', height: '36px', display: 'flex', alignItems: 'center' }}>
                {this.exibirMenu() ? (
                    <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <IconButton
                            color="inherit"
                            aria-label="Menu"
                            title={'Menu'}
                            onClick={this.toggleMenu}
                            size="large"
                        >
                            <MenuIcon />
                        </IconButton>
                        {this.renderDrawerMenu}
                        <Typography
                            display={'inline'}
                            color="inherit"
                            component="h1"
                            variant="h6"
                            style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Secretaria Eletrônica
                        </Typography>
                        {this.renderModuloSelecionado}
                    </Box>
                ) : (
                    <Box>
                        <Typography
                            display={'inline'}
                            component="h1"
                            variant="h6"
                            color="inherit"
                            style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                marginLeft: '16px'
                            }}
                        >
                            Secretaria Eletrônica
                        </Typography>
                        {this.renderModuloSelecionado}
                    </Box>
                )}
            </Box>
        );
    }

    get isUsuarioAutorizadoAEditarParametros() {
        return this.usuarioStore.isUsuarioAdmin();
    }

    get renderDrawerMenu() {
        return (
            <Drawer
                anchor="left"
                open={this.menuAberto}
                onClose={this.toggleMenu}
            >
                <List>
                    {this.isComponenteHabilitado('Calendario') && (
                        <ListItemButton onClick={this.handleClickCalendario}>
                            <ListItemIcon>
                                <IconeCalendario />
                            </ListItemIcon>
                            <ListItemText primary="Calendário de pautas e sessões" />
                        </ListItemButton>
                    )}
                    {this.isComponenteHabilitado('AdicionarProcessosPauta') &&
                        this.isComponenteHabilitado('Calendario') && (
                            <ListItemButton onClick={this.handleClickAdicionarProcessosPauta}>
                                <ListItemIcon>
                                    <FormatListBulleted />
                                </ListItemIcon>
                                <ListItemText primary="Pauta de julgamento" />
                            </ListItemButton>
                        )}
                    {this.isComponenteHabilitado('ModuloPreSessao') && (
                        <ListItemButton onClick={this.handleClickPreSessao}>
                            <ListItemIcon>
                                <ScreenSearchDesktopOutlinedIcon />
                            </ListItemIcon>
                            <ListItemText primary="Pré-sessão" />
                        </ListItemButton>
                    )}
                    <ListItemButton onClick={this.handleClickSalaSessao}>
                        <ListItemIcon>
                            <Gavel />
                        </ListItemIcon>
                        <ListItemText primary="Sala de sessão" />
                    </ListItemButton>
                    {this.isComponenteHabilitado('EdicaoParametros') && this.isUsuarioAutorizadoAEditarParametros && (
                        <ListItemButton onClick={this.handleClickConfiguracaoParametros}>
                            <ListItemIcon>
                                <Settings />
                            </ListItemIcon>
                            <ListItemText primary="Configurações do sistema" />
                        </ListItemButton>
                    )}
                </List>
            </Drawer>
        );
    }

    get renderModuloSelecionado() {
        if (!this.rota) {
            return null;
        }

        return (
            <>
                <Typography
                    display={'inline'}
                    color="inherit"
                    component="h2"
                    variant="h6"
                    style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        marginLeft: '8px',
                        marginRight: '8px'
                    }}
                >
                    {'➤'}
                </Typography>
                <Typography
                    display={'inline'}
                    color="inherit"
                    component="h2"
                    variant="h6"
                    style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        marginRight: '8px'
                    }}
                >
                    {this.rota.descricao}
                </Typography>
            </>
        );
    }
}

export default inject('stores')(observer(MenuAppBar));
